import { buildQueryVariables } from '../../helpers';

/**
 * @param {{
 *   CustomerBonusService: ReturnType<import('../../services/CustomerBonusService').default>,
 * }} param0
 */
export default function customerBonusUseCase({ CustomerBonusService }) {
  const getCustomers = (variables) => {
    const serviceVariables = buildQueryVariables({
      limit: variables.limit,
      offset: variables.offset,
      search: variables.search,
      id: variables.id,
    });

    return CustomerBonusService.getCustomers(serviceVariables);
  };

  const getHistory = (variables) => {
    const serviceVariables = buildQueryVariables({
      limit: variables.limit,
      offset: variables.offset,
      customerId: variables.customerId,
    });

    return CustomerBonusService.getHistory(serviceVariables);
  };

  const topUpBalance = (input) => CustomerBonusService.topUpBalance(input);

  const chargeFromBalance = (input) => CustomerBonusService.chargeFromBalance(input);

  return {
    getCustomers,
    getHistory,
    topUpBalance,
    chargeFromBalance,
  };
}
